// Api Base Url
// const CRM_BASE_URL = "http://122.170.105.239:3030/api";
// const CRM_BASE_URL = "http://192.168.1.57:3030/api";
// const BASE_URL = "http://restapi.adequateshop.com/api";
// const BASE_URL = "http://18.215.233.17:82/v1.0";
// const BASE_URL = "http://20.204.24.208:82/v1.0";
// const BASE_URL = "http://20.198.3.2:82/v1.0"; 
 const BASE_URL = "https://dashboardapi.sswhite.co/v1.0"; 

// const BASE_URL = "https://localhost:18344/v1.0";

// Api End Points
const endPoints = {
  LOGIN: {
    AUTH: BASE_URL + "/authenticate/token",
    LOGOUT: BASE_URL + "/authenticate/logOut",
    FORGOT_EMAIL: BASE_URL + "/authenticate/SendForgetPasswordEmail",
    IS_EMAIL_VALID: BASE_URL + "/authenticate/IsEmailValid",
    SET_NEW_PASSWORD: BASE_URL + "/authenticate/SetNewPassword",
  },
  USER: {
    USER_DETAIL: BASE_URL + "/Dashboard/GetUserDetailsById",
    CHANGE_PASSWORD: BASE_URL + "/Dashboard/ChangePassword",
  },
  DASHBOARD: {
    TEAM: BASE_URL + "/Dashboard/GetSSWhiteTeamDetails",
    NOTIFICATIONS: BASE_URL + "/Dashboard/UserNotification",
    GET_NOTIFICATIONS: BASE_URL + "/Dashboard/GetNotifications",
  },
  TIME_ATTENDANCE: {
    CHECK_IN_OUT: BASE_URL + "/TimeAndAttendance/InsertInOutDetailsByPunchType",
    CHECK_IN_OUT_STATUS:
      BASE_URL + "/TimeAndAttendance/GetInOutStatusByPunchTypeUserId",
    RECORDS: BASE_URL + "/TimeAndAttendance/GetInOutDetailsByUserId",
    BUILDING: BASE_URL + "/TimeAndAttendance/GetUsersInOutStatus",
  },
  EXPENSE_PURCHASE_ORDER: {
    CREATE_EPO_DROPDOWN: BASE_URL + "/ExpensePurchaseOrder/GetAllEPODropDowns",
    GET_USER_LIMIT:
      BASE_URL + "/ExpensePurchaseOrder/GetAuthorizedLimitByUserId",
    ADD_EPO: BASE_URL + "/ExpensePurchaseOrder/AddOrEditEpo",
    //mpc epo view is same for the my EPOs
    MPC_EPO_VIEWER: BASE_URL + "/ExpensePurchaseOrder/GetAllEpos",
    MPC_YOUR_VOTE: BASE_URL + "/ExpensePurchaseOrder/GetMpcVoteForEpo",
    MPC_ALL_VOTE: BASE_URL + "/ExpensePurchaseOrder/GetAllMpcVoteForEpo",
    SUBORDINATE_EPO_LIST:
      BASE_URL + "/ExpensePurchaseOrder/GetMySubordinateEpos",
    APPROVAL_LIST_EPO: BASE_URL + "/ExpensePurchaseOrder/GetMyApprovalForEpo",
    EPO_DETAIL_BY_ID: BASE_URL + "/ExpensePurchaseOrder/GetEpoDetailsByEpoId",
    VOID_EPO_BY_ID: BASE_URL + "/ExpensePurchaseOrder/VoidEpoByUserId",
    APPROVAL_OR_DENIED_EPO: BASE_URL + "/ExpensePurchaseOrder/ApproveOrDenyEpo",
    APPROVAL_OR_DENIED_EPO_VIA_MAIL: BASE_URL + "/ExpensePurchaseOrder/ApproveOrDenyEpoViaMail",
    GET_MPC_VOTE_LIST:
      BASE_URL + "/ExpensePurchaseOrder/GetMpcVoteDetailsByEpoId",
    GET_EPO_MODULES_COUNTS:
      BASE_URL + "/ExpensePurchaseOrder/GetEpoModulesCounts",
    GET_ALL_VENDOR_OR_EMPLOYEE_DETAILS_BY_NAME:
      BASE_URL + "/ExpensePurchaseOrder/GetAllVendorOrEmployeeDetailsByName",
    DOWNLOAD_PDF_EPO: BASE_URL + "/ExpensePurchaseOrder/DownloadPdf",
    ADD_VENDOR: BASE_URL + "/ExpensePurchaseOrder/AddVendor",
    GET_CURRENCY_VALUE:
      BASE_URL + "/admin/common/GetCurrencyValue",
  },
  ATTENDANCE_CHANGE: {
    GET_FTO_LIST:
      BASE_URL + "/AttendanceChange/GetAllDepartmentOrUserFtoByUserId",
    GET_FTO_LIST_BY_DATES:
      BASE_URL + "/AttendanceChange/GetDepartmentFtoByUserId",
    CREATE_FTO_REQUEST: BASE_URL + "/AttendanceChange/CreateAttendanceFto",
    GET_FTO_BY_ID: BASE_URL + "/AttendanceChange/GetAttendanceFtoById",
    APPROVE_OR_DENY_FTO: BASE_URL + "/AttendanceChange/ApproveOrDenyFto",
    GET_FTO_BY_ID_FOR_MAIL: BASE_URL + "/AttendanceChange/GetAttendanceFtoByIdForMail",
    APPROVE_OR_DENY_FTO_MAIL: BASE_URL + "/AttendanceChange/ApproveOrDenyFtoViaMail",
    UPDATE_FTO: BASE_URL + "/AttendanceChange/UpdateAttendanceFto",
    ADD_OR_UPDATE_VISITOR: BASE_URL + "/AttendanceChange/AddOrUpdateVisitor",
    ADD_OR_UPDATE_VISITOR_WITHOUT_LOGIN: BASE_URL + "/AttendanceChange/AddOrUpdateVisitorWithoutLogin",
    GET_ALL_VISITOR: BASE_URL + "/AttendanceChange/GetAllVisitors",
    GET_VISITOR_BY_ID: BASE_URL + "/AttendanceChange/GetVisitorById",
    DELETE_VISITOR_BY_ID: BASE_URL + "/AttendanceChange/ChangeVisitorStatus",
    DOWNLOAD_VISITOR: BASE_URL + "/AttendanceChange/DownloadPdf",
    APPROVAL_OR_DENIED_VISITOR_VIA_MAIL: BASE_URL + "/AttendanceChange/ApproveOrDenyVisitorViaMail",
    GET_FTO_TYPE: BASE_URL + "/AttendanceChange/GetAllFtoType",
    EXPORT_APPROVE_FTO: BASE_URL + "/AttendanceChange/ExportApprovedFtoExcel",
      GET_LEAVE_SUMMERY: BASE_URL + "/AttendanceChange/GetLeaveSummeryByUserId",

  },
  DOCUMENT_MANAGEMENT: {
    GET_ALL_DOCUMENTS: BASE_URL + "/Document/GetAllDocuments",
    GET_ASSOCIATED_DOCUMENTS: BASE_URL + "/Document/GetAssociateDocuments",
    GET_USER_AND_DROPDOWN_DATA:
      BASE_URL + "/Document/GetDocumentsDropdownAndUserDetails",
    GET_EMPLOYEE_BY_DEPARTMENT: BASE_URL + "/Document/GetEmployeeByDepartment",
    ADD_OR_EDIT_DOCUMENT: BASE_URL + "/Document/AddOrEditDocument",
    GET_DOCUMENT_BY_ID: BASE_URL + "/Document/GetDocumentById",
    APPROVE_DOCUMENT: BASE_URL + "/Document/ApproveDocument",
    DOWNLOAD_PDF_DOCUMENT: BASE_URL + "/Document/DownloadPdf",
  },

  ADMIN: {
    // Common/GetAllEmployeeDetailsDropdown
    GET_ALL_EMPLOYEE_DROPDOWN:
      BASE_URL + "/admin/common/GetAllEmployeeDetailsDropdowns",
 DOWNLOAD_PDF_ADD_EMPLOYEE: BASE_URL + "/admin/common/DownloadEmployeePdf",
    GET_EMPLOYEE_BYID: BASE_URL + "/admin/common/GetEmployeeByEmployeeId",

    //Add Employee
    ORGANIZATION: BASE_URL + "/admin/common/GetOrganization",
    TRAININGLIST: BASE_URL + "/admin/common/GetTrainingList",
    ADD_EDIT_EMPLOYEE: BASE_URL + "/admin/common/AddOrEditEmployee",
    ADD_BULK_EMPLOYEE: BASE_URL + "/admin/common/BulkInsertEmployees",
    JOB_DESCRIPTION: BASE_URL + "/admin/common/GetEmployeeJobDescription",
    REPORTING_USER: BASE_URL + "/admin/common/GetReportingUnder",
    CHANGE_EMPLOYEE_STATUS: BASE_URL + "/admin/common/ChangeEmployeeStatus",
    GET_ALL_EMPLOYEE_TYPE: BASE_URL + "/admin/common/GetAllEmployeeTypes",
    SAMPLE_FILE_DOWNLOAD: BASE_URL + "/admin/common/BulkInsertSamplePath",


    DEPARTMENT:
      BASE_URL + "/admin/common/GetDepartmentByDepartmentSupervisorName",
    CHANGE_EMP_DEPARTMENT: BASE_URL + "/admin/common/ChangeEmployeeDepartment",
    MANAGER_USER: BASE_URL + "/admin/common/GetManager",
    MASTER_DEPARTMENT: BASE_URL + "/admin/common/GetAllDepartments",
    MASTER_DESIGNATION: BASE_URL + "/admin/common/GetDesignationByDepartmentId",

    SAVE_TRAINING_DETAILS: BASE_URL + "/admin/common/SaveEmployeeTraining",

    //ADD_EMPLOYEE: BASE_URL + "/admin/common/AddNewEmployee",

    CHECK_EMPLOYEE_EXIST: BASE_URL + "/admin/common/CheckIfEmployeeIdExists",
    CHECK_EMAIL_EXIST: BASE_URL + "/admin/common/CheckIfEmailAddressExists",

    //Employee Limit
    EMPLOYEE_LIMIT: BASE_URL + "/admin/common/GetAllEmployeeLimit",

    OFFICE_EMPLOYEE: BASE_URL + "/admin/common/GetAllOfficeEmployees",

    EMPLOYEE_DETAIL: BASE_URL + "/admin/common/GetEmployeeByEmployeeId",

    GET_POSITION: BASE_URL + "/admin/common/GetEmployeePosition",

    UPDATE_LIMIT: BASE_URL + "/admin/common/UpdateEmployeeLimit",
    CHANGE_STATUS: BASE_URL + "/admin/common/ChangeEmployeeStatus",
    ALL_EMP_DETAILS_DROPDOWNS:
      BASE_URL + "/admin/common/GetAllEmployeeDetailsDropdowns",

    //Document Approval
    DOCUMENT_APPROVAL: BASE_URL + "/admin/common/GetDocumentApprovals",
    UPDATE_APPROVAL_LIST: BASE_URL + "/admin/common/UpdateDocumentApprovalList",

    //Roles and Rights
    GET_USER_ROLES_RIGHTS: BASE_URL + "/admin/common/GetUserRights",
    GET_ROLES: BASE_URL + "/admin/common/GetRoles",
    GET_RIGHTS_BY_ID: BASE_URL + "/admin/common/GetRightsAccessByRoleId",
    UPDATE_RIGHTS_BY_ID: BASE_URL + "/admin/common/UpdateRightsAccessByRoleId",
    AddOrEditOrDeleteDepartment: BASE_URL + "/admin/common/AddOrEditOrDeleteDepartment",
    AddOrEditOrDeleteTraining: BASE_URL + "/admin/common/AddOrEditOrDeleteTraining",
    AddOrEditOrDeleteDesignation: BASE_URL + "/admin/common/AddOrEditOrDeleteDesignation",
    GetDesignationByDepartmentId : BASE_URL + "/admin/common/GetDesignationByDepartmentId",
  },
  GENRIC_INFO: {
    GET_HIRARCHY: BASE_URL + "/HumanResource/GetHierarchy"
  },

  HUMAN_RESOURCE: {
    //Pre-reqruitement Process

    GET_RECRUITEE_DROPDOWN_DATA:
      BASE_URL + "/HumanResource/GetAllRecruiteeDropdowns",
    ADD_RECRUITEE: BASE_URL + "/HumanResource/AddOrEditRecruitee",
    ALL_RECRUITEES: BASE_URL + "/HumanResource/GetAllRecruitees",
    DOWNLOAD_PDF_HR: BASE_URL + "/HumanResource/DownloadPdf",
    DownloadRecruiteeEvalutionPdf: BASE_URL + "/HumanResource/DownloadEvalutionPdf",
    EvalutionForm: BASE_URL + "/HumanResource/GetRecruiteeById",
    AddEvalutionForm: BASE_URL + "/HumanResource/GetRecruteeEvalution",
    EvalutionProcessGenral: BASE_URL + "/HumanResource/AddOrEditEvaluation",
    EvalutionProcessTech1: BASE_URL + "/HumanResource/AddOrEditEvaluationTech1",
    EvalutionProcessTech2: BASE_URL + "/HumanResource/AddOrEditEvaluationTech2",
    EvalutionProcessHR: BASE_URL + "/HumanResource/AddOrEditEvaluationHr",
    SENDEVALUTIONFORM: BASE_URL + "/HumanResource/SendEvalutionForm",
    GetEvalutionById: BASE_URL + "/HumanResource/GetEvalutionById",
    RecordingReq: BASE_URL + "/HumanResource/AddOrEditRecordingRequest",
    GetAllRecording: BASE_URL + "/HumanResource/GetAllRecordingRequest",
    ApproveRecording: BASE_URL + "/HumanResource/ApproveOrDenyRecordingViaMail",

    //Welcome New Employee
    WELCOME_NEW_EMPLOYEE:
      BASE_URL + "/HumanResource/Notification/SendNewEmployeeNotification",

    //Employee Of The Month
    ADD_EMP_OF_THE_MONTH:
      BASE_URL + "/HumanResource/AddEmployeeOfTheMonthNominee",
    GET_EXTRAORDINARY_ABOUT_NOMINEE:
      BASE_URL + "/HumanResource/GetAllExtraOrdinaryAboutNominee",
    GET_ALL_EMP_OF_The_MONTH_NOMINEES:
      BASE_URL + "/HumanResource/GetAllEmployeeOfTheMonthNominees",
    GET_NOMINEE_BYID: BASE_URL + "/HumanResource/GetNomineeByNomineeId",

    //Lat's Know Each Other Details
    ADD_LETS_KNOW_EACH_OTHER: BASE_URL + "/HumanResource/AddLetsKnowEachOther",
    GATE_ALL_LKEO_DETAILS: BASE_URL + "/HumanResource/GetAllLetsKnowEachOther",
    GET_LKEO_BY_ID: BASE_URL + "/HumanResource/GetLetsKnowEachOtherById",

    //Gate Pass
    ADD_GATE_PASS: BASE_URL + "/HumanResource/AddGatepass",
    GET_ALL_GP_DETAILS: BASE_URL + "/HumanResource/GetAllGatepasses",
    GET_GP_DETAILS_BYID: BASE_URL + "/HumanResource/GetGatepassById",

    // Leave sheet
    ADD_NEW_LEAVE: BASE_URL + "/HumanResource/CreateNewLeaveSheet",
    GET_EMP_LEAVE_DETAILS_BYID:
      BASE_URL + "/HumanResource/GetEmployeeLeaveDetailsById",
    GET_ALL_LEAVESHEET: BASE_URL + "/HumanResource/GetAllLeaveSheets",
    GET_LEAVESHEET_DETAILS_BYID:
      BASE_URL + "/HumanResource/GetLeaveSheetDetailsById",

    // Training Course
    ADD_NEW_DEPRT_COURSE: BASE_URL + "/HumanResource/AddNewDepartmentCourse",
    GET_ALL_DEPRT_COURSE: BASE_URL + "/HumanResource/GetAllDepartmentCourses",
    GET_DEPRT_COURSE_BYID:
      BASE_URL + "/HumanResource/GetDepartmentCourseDetailsById",

    // Training
    GET_DEPT_COURSE_BY_DEPTID:
      BASE_URL + "/HumanResource/GetDepartmentCoursesByDepartmentId",
    ADD_OR_EDIT_TRAINING: BASE_URL + "/HumanResource/AddOrEditTraining",
    GET_ALL_TRAINING_LIST: BASE_URL + "/HumanResource/GetAllTrainings",
    GET_TRAINING_BY_ID: BASE_URL + "/HumanResource/GetTrainingById",
    DELETE_TRAINING: BASE_URL + "/HumanResource/DeleteTrainingById",
    GET_ALL_INSTRUCTOR_BY_TRAINING_DROPDOWN:
      BASE_URL + "/HumanResource/GetAllInstructorByTrainingDropDownList",
    GET_ALL_EMPLOYEE_BY_TRAINING_DROPDOWN:
      BASE_URL + "/HumanResource/GetAllEmployeeTrainingDropDownList",
    GET_ALL_COURSE_BY_TRAINING_DROPDOWN:
      BASE_URL + "/HumanResource/GetAllCourseByTrainingDropDownList",
    GET_ALL_HOURS_BY_TRAINING_DROPDOWN:
      BASE_URL + "/HumanResource/GetAllHoursByTrainingDropDownList",
    GET_TRAINING_DETAILS_BY_EMPLOYEE_ID:
      BASE_URL + "/HumanResource/GetTrainingDetailsOfEmployeeByEmployeeId",
    GET_TRAINING_DETAILS_BY_COURSE_ID:
      BASE_URL + "/HumanResource/GetTrainingDetailsOfCourseByCourseId",
    GET_TRAINING_DETAILS_BY_INSTRUCTOR_NAME:
      BASE_URL +
      "/HumanResource/GetTrainingDetailsOfInstructorByInstructorName",

    // Email For Training
    SEND_TRAINING_NOTIFICATION:
      BASE_URL + "/HumanResource/Notification/SendTrainingNotification",

    ADD_OR_EDIT_QUESTION: BASE_URL + "/HumanResource/AddOrEditQuestion",
    GET_ALL_QUESTIONS_CATEGORIES: BASE_URL + "/HumanResource/GetAllQuestionCategories",
    GET_ALL_QUESTIONS: BASE_URL + "/HumanResource/GetAllQuestions",
    GET_QUESTION_BY_ID: BASE_URL + "/HumanResource/GetQuestionById",
    CHANGE_QUESTION_STATUS: BASE_URL + "/HumanResource/ChangeQuestionStatus",
    ADD_CANDIDATE_CV: BASE_URL + "/HumanResource/AddCandidateResume",
    GET_ALL_CANDIDATE_CV: BASE_URL + "/HumanResource/GetAllCandidateResume",
  },

  CHANGE_REQUEST: {
    ADD_NEW_CHANGE_REQUEST_INFO:
      BASE_URL + "/ChangeRequest/AddNewChangeRequestInfo",
    GET_ALL_CHANGE_REQUESTS_LIST:
      BASE_URL + "/ChangeRequest/GetAllChangeRequestsList",
    GET_CHANGE_REQUEST_BY_ID:
      BASE_URL + "/ChangeRequest/GetChangeRequestDetailsById",
    DOWNLOAD_CR_PDF_DOCUMENT: BASE_URL + "/ChangeRequest/DownloadCRPdf",
  },
  PHONEBOOK: {
    GET_ALL: BASE_URL + "/phonebook/GetAll",
  },
  Ticket: {
 GET_ALL: BASE_URL + "/ChangeRequest/Applications",
 ApproveTicket: BASE_URL + "/ChangeRequest/ApproveTicket",
 GetReopenTicketByID: BASE_URL + "/ChangeRequest/GetReopenTicketByID",
 ReassignTicket: BASE_URL + "/ChangeRequest/TicketAssignmentHistory",
 GetAllTickets: BASE_URL + "/ChangeRequest/GetAllTickets",
    GET_MODULES: BASE_URL + "/ChangeRequest/Modules",
    GET_SUBMODULES: BASE_URL + "/ChangeRequest/SubModules",
            SendStatuschange: BASE_URL + "/ChangeRequest/SendStatuschange",
        savetickit: BASE_URL + "/ChangeRequest/AddNewTicket",
        Gettickit: BASE_URL + "/ChangeRequest/GetAllTicketssList",
        sendMessage: BASE_URL + "/ChangeRequest/send-message",
        getMessages: BASE_URL + "/ChangeRequest"
  },
};

module.exports.api = endPoints;
